<div class="esn-version-tabs" role="tablist" [attr.aria-label]="label()">
  @for (tab of tabs(); track tab.value; let i = $index) {
    <button
      #tabButton
      type="button"
      role="tab"
      class="esn-version-tabs__tab"
      [class.esn-version-tabs__tab--selected]="tab.value === current()"
      [disabled]="tab.disabled ?? false"
      [attr.aria-selected]="tab.value === current()"
      [attr.aria-controls]="controls()"
      [attr.tabindex]="tab.value === current() ? 0 : -1"
      (click)="select(tab)"
      (keydown)="onKeydown($event, i)"
    >
      {{ tab.label }}
    </button>
  }
</div>
